import { notification } from "antd";

let isAlertActive = false;

const alert = (
  { title, type = "info", description, duration = 5, ...restOptions }: any = {},
  onClose?: () => void,
  onClick?: () => void,
  onDismiss?: () => void
) => {
  return new Promise((resolve) => {
    if (isAlertActive) return;
    isAlertActive = true;

    (notification as any)[type]({
      message: title,
      description,
      duration, // Time for the toast to disappear (seconds)
      placement: "top",
      style: { borderRadius: "5px !important" },
      onClose: () => {
        isAlertActive = false;
        onClose?.();
        resolve(true);
      },
      onClick: () => {
        isAlertActive = false;
        onClick?.();
        resolve(true);
      },
      onDismiss: () => {
        isAlertActive = false;
        onDismiss?.();
        resolve(true);
      },
      ...restOptions,
    });
  });
};

export { alert };
